// frontend/src/components/grid/productFields.js
//
// The row fields the Product cell reads when a grid names none of its own.

export const PRODUCT_FIELD_DEFAULTS = {
  imageField: 'image_url',
  nameField: 'item_name',
  skuField: 'sku',
  codeField: 'item_code',
};
